import { ref } from 'vue'
import { Dropdown } from 'bootstrap'

export function useDropdown() {
  const dropdowns = ref([])

  const dropDownToggleF = (e) => {
    if (
      !e.currentTarget ||
      !e.currentTarget.classList.contains('dropdown-toggle-b')
    ) {
      return
    }

    dropdowns.value.forEach(item => {
      if (item !== e.currentTarget && item.classList.contains('show')) {
        const drop = Dropdown.getInstance(item)
        drop.hide()
      }
    })

    const drop = Dropdown.getOrCreateInstance(e.currentTarget, {
      autoClose: true,
      reference: '.container-fluid'
    })

    drop.toggle()

    dropdowns.value.push(e.currentTarget)
  }

  const hideDropdowns = (e) => {
    if (
      e.target &&
      e.target.tagName !== 'path' &&
      !e.target.classList.contains('dropdown-toggle-b') &&
      !e.target.classList.contains('dropdown-toggle-icon')
    ) {
      dropdowns.value.forEach(item => {
        if (item.classList.contains('show')) {
          const drop = Dropdown.getInstance(item)
          drop.hide()
        }
      })
    }
  }

  return {
    dropDownToggleF,
    hideDropdowns
  }
}
